/**
 * Internationalization labels for glossary term pages
 * Ensures consistency across all terms in the same locale
 */

type GlossaryLabels = {
  authorTitle: string
  publishedLabel: string
  updatedLabel: string
  tocTitle: string
  relatedTermsHeading: string
}

const GLOSSARY_LABELS: Record<string, GlossaryLabels> = {
  'en-us': {
    authorTitle: 'Written by',
    publishedLabel: 'Published',
    updatedLabel: 'Updated',
    tocTitle: 'Table of Contents',
    relatedTermsHeading: 'Related Terms',
  },
  'en-gb': {
    authorTitle: 'Written by',
    publishedLabel: 'Published',
    updatedLabel: 'Updated',
    tocTitle: 'Table of Contents',
    relatedTermsHeading: 'Related Terms',
  },
  'de-de': {
    authorTitle: 'Verfasst von',
    publishedLabel: 'Veröffentlicht',
    updatedLabel: 'Aktualisiert',
    tocTitle: 'Inhaltsverzeichnis',
    relatedTermsHeading: 'Verwandte Begriffe',
  },
  'de-at': {
    authorTitle: 'Verfasst von',
    publishedLabel: 'Veröffentlicht',
    updatedLabel: 'Aktualisiert',
    tocTitle: 'Inhaltsverzeichnis',
    relatedTermsHeading: 'Verwandte Begriffe',
  },
  'en-nl': {
    authorTitle: 'Written by',
    publishedLabel: 'Published',
    updatedLabel: 'Updated',
    tocTitle: 'Table of Contents',
    relatedTermsHeading: 'Related Terms',
  },
  'en-de': {
    authorTitle: 'Written by',
    publishedLabel: 'Published',
    updatedLabel: 'Updated',
    tocTitle: 'Table of Contents',
    relatedTermsHeading: 'Related Terms',
  },
  'nl-nl': {
    authorTitle: 'Geschreven door',
    publishedLabel: 'Gepubliceerd',
    updatedLabel: 'Bijgewerkt',
    tocTitle: 'Inhoudsopgave',
    relatedTermsHeading: 'Gerelateerde termen',
  },
}

/**
 * Get glossary labels for a given locale
 * Falls back to English if locale not found
 */
export function getGlossaryLabels(locale: string): GlossaryLabels {
  return GLOSSARY_LABELS[locale] || GLOSSARY_LABELS['en-us']
}
